export const types = {
  SET_ROOM_RANKER_CONFIG: 'SET_ROOM_RANKER_CONFIG',
  SET_ROOM_RANKER_CONFIG_LOADING: 'SET_ROOM_RANKER_CONFIG_LOADING',
  SET_ROOM_RANKER_DATA_LOADING: 'SET_ROOM_RANKER_DATA_LOADING',
  SAVE_ROOM_RANKER_TABLE_DATA: 'SAVE_ROOM_RANKER_TABLE_DATA',
};
